import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import SectionHeader from '../sectionHeader'

const Banner = () => {
  
  return (
    <div class="voloto-banner">
      <Container className='h-85'>
        <Row className=''>
          <Col lg={10} md={10} sm={10} className=''>
            <SectionHeader mainText1="CAREERS"  />
            <h1>We Are Outstanding.</h1>
            <p>We are committed towards Success and<br></br> Career Growth of our employees.</p>
          </Col>
          <Col lg={2} md={2} sm={2} className='career-rotate'>
             <img src="images/career.svg" alt="Career Page" />
          </Col>
        </Row>
      </Container>
      
     <img className='banner-vector' src="images/Union.svg" alt="vector" />
    </div>
  )
}

export default Banner
